export default {
    minWidth: 0,
    p: 0,
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    "& .MuiButton-startIcon": {
        mr: 0,
        ml: 0,
        color: "rgba(0,0,0, 0.54)",
    },
    ":hover": {
        backgroundColor: "rgb(240, 240, 240)",
    },
};
